export default __webpack_public_path__ + "static/media/rewards_icon_products.c1065375.svg";